<template>
  <div class="cards mx-auto shadow cards-height blogs">
    <div class="h1 bg-light py-2 primary-font">Blogs</div>
    <!-- Use the following Vue 'component' if we need to wait on loaded content -->
    <!-- https://vuejs.org/v2/api/?#keep-alive -->
    <!-- Use skeleton loaders -->
    <!-- https://bootstrap-vue.org/docs/components/skeleton -->
    <div
      class="d-flex justify-content-center mb-5 pt-5 border-dark border-top"
      v-if="isLoading"
    >
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div v-else-if="filteredBlogs.length !== 0 && !isLoading">
      <div v-for="item in filteredBlogs" :key="item.id">
        <div
          class="d-inline-block w-50 border-right border-dark border-bottom border-top no-wrap-size-undefined"
        >
          {{ item.title }}
        </div>
        <div class="d-inline-block w-50 border-dark border-bottom border-top">
          {{ formatDate(item.datetime) }}
        </div>
        <div class="bg-white p-4 text-container" v-html="item.blog"></div>
        <div class="bg-white mb-4 text-center font-weight-bold" id="continue" @click="continueToBlog(item.id, item.title)">Continue reading...</div>
      </div>
    </div>
    <div v-else-if="!isLoading">
      <div class="d-inline-block w-100 border-dark border-bottom border-top">No blogs found!</div>
      <div class="bg-white p-4 text-container">
        <img src="https://cdn2.iconfinder.com/data/icons/delivery-and-logistic/64/Not_found_the_recipient-no_found-person-user-search-searching-4-512.png" width="102px" height="102px"/>
        <div class="text-center warning-font font-weight-bold">Please retry your search.</div>
      </div>
    </div>
  </div>
</template>

<script>
import blogService from "@/services/blogService";
import testService from "@/services/testService";
import moment from "moment";
import { APP_CONFIG } from "@/common/flags";

export default {
  name: "BlogsView",
  data() {
    return {
      blogs: null,
      isLoading: false,
      filteredBlogs: null
    };
  },
  props: {
    // TODO: REMEMBER: rename this prop!
    model: {
      type: String,
      default: ""
    }
  },
  created() {
    this.GetBlogsAsync();
  },
  methods: {
    async GetBlogsAsync() {
      // GetBlogsAsync() {
      this.isLoading = true;
      let response = null;
      if (APP_CONFIG.ENV === "PROD") {
        response = await blogService.getBlogsAsync();
        // var response = await testService.getAllBlogs();
        this.isLoading = false;
        // https://googleapis.dev/nodejs/storage/latest/Bucket.html#get
        this.blogs = response.data.blogs;
        // this.blogs = response.blogs;
        this.filteredBlogs = this.blogs;
      } else {
        response = await testService.getAllBlogs();
        this.isLoading = false;
        // https://googleapis.dev/nodejs/storage/latest/Bucket.html#get
        // this.blogs = response.data.blogs;
        this.blogs = response.blogs;
        this.filteredBlogs = this.blogs;        
      }
    },
    formatDate(datetime) {
      return moment(datetime).format("MMM Do YYYY");
    },
    continueToBlog(blogId, blogTitle) {
      this.$router.push({ name: "Blog", params: { id: blogId, title: blogTitle } });
    },
  },
  watch: {
    model: function (nval) {
      this.filteredBlogs = [];
      if (nval !== '') {
        this.blogs.forEach(blog => {
          if (blog.title.toLowerCase().includes(nval.toLowerCase()))
          {
            // only display results that match
            this.filteredBlogs.push(blog);
          }
        });
      } else {
        this.filteredBlogs = this.blogs;
      }
    }
  }
};
</script>

<style lang="scss">
.blogs {
  margin-bottom: 5rem;
  .h1 {
    margin-bottom: 0rem;
  }
  .text-container {
    overflow: hidden;
    text-overflow: hidden;
    height: 10rem;
  }
  #continue:hover {
    text-decoration: underline;
  }
}
</style>
